module.exports = __webpack_public_path__ + "media/project-boost.c2fdbe1e.mp4";